import {
  Button,
  CurrencySelectInput,
  LongArrowIcon,
  SearchInput,
  TransparentButton,
} from '@libs/components';
import styled from 'styled-components';

export const SwapButton = styled(TransparentButton)<{ isSwapped?: boolean }>`
  position: absolute;
  z-index: ${({ theme }) => theme.zIndex.low};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.surface.default};
  border: 4px solid ${({ theme }) => theme.colors.surface.tertiary};
  transform: ${({ isSwapped }) => (isSwapped ? 'rotate(0)' : 'rotate(180deg)')};
  transition: 0.5s all ease;
`;
export const SwapButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CurrencySelectInputWrapper = styled.div`
  margin-bottom: 0.4rem;
`;

export const SelectSearchWrapper = styled.div`
  padding: 0.8rem 3.2rem 1.2rem;
  min-width: 100%;
  ${({ theme }) => theme.media.tabletL`
    min-width:50rem;
  `}
`;
export const CustomButton = styled(Button)`
  margin-top: 2rem;
`;

export const ArrowIcon = styled(LongArrowIcon)`
  transform: rotate(-90deg);
`;
export const CustomSearch = styled(SearchInput)`
  border-radius: ${({ theme }) => theme.borderRadius.x8};
  .input-placeholder {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
export const CustomCurrencySelectInput = styled(CurrencySelectInput)`
  .error-message {
    display: none;
    height: 0;
  }
`;
